import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCartShopping } from '@fortawesome/pro-light-svg-icons';

export type ProLightCartShoppingProps = IconComponentProps;

export const ProLightCartShopping = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCartShoppingProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCartShopping}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCartShopping}
    />
  );
};

ProLightCartShopping.displayName = 'ProLightCartShopping';
